import React, { useState } from 'react';
import { Box, Flex, Text, Avatar, Divider, RadioGroup, Radio, Stack, Select, VStack } from '@chakra-ui/react';
import { Home, Settings, LogOut, Download } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
const TEAL = '#00897B';
const SIDEBAR_BG = '#C8E6C0';
type MenuItemProps = {
  icon: React.ReactNode;
  label: string;
  onClick?: () => void;
};
function MenuItem({
  icon,
  label,
  onClick
}: MenuItemProps) {
  return <Flex align="center" gap={4} px={5} py={3} cursor="pointer" borderRadius="md" _hover={{
    bg: 'rgba(0,137,123,0.12)'
  }} onClick={onClick} role="button" tabIndex={0} onKeyDown={e => e.key === 'Enter' && onClick?.()} data-id="element-77">
      <Box color={TEAL} flexShrink={0} data-id="element-78">
        {icon}
      </Box>
      <Text color={TEAL} fontWeight="500" fontSize="md" data-id="element-79">
        {label}
      </Text>
    </Flex>;
}
export function Sidebar() {
  const [selection, setSelection] = useState<string>('boards');
  const [boardValue, setBoardValue] = useState<string>('');
  const [committeeValue, setCommitteeValue] = useState<string>('');
  const navigate = useNavigate();
  const handleSelectionNavigate = (value: string) => {
    setBoardValue('');
    setCommitteeValue('');
    setSelection(value);
  };
  const handleBoardSelect = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const val = e.target.value;
    setBoardValue(val);
    if (val) navigate('/board');
  };
  const handleCommitteeSelect = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const val = e.target.value;
    setCommitteeValue(val);
    if (val) navigate('/committee');
  };
  return <Box as="nav" bg={SIDEBAR_BG} w="290px" minW="290px" position="fixed" top="64px" left={0} bottom={0} zIndex={90} display="flex" flexDirection="column" overflowY="auto" data-id="element-80">
      {/* User Box */}
      <Flex align="center" gap={3} px={4} py={4} borderBottom="1px solid rgba(0,137,123,0.25)" data-id="element-81">
        <Avatar name="Keith Price" bg="#7B1FA2" color="white" size="md" fontWeight="bold" getInitials={() => 'KP'} data-id="element-82" />
        <Box data-id="element-83">
          <Text fontWeight="bold" color={TEAL} fontSize="md" lineHeight="1.2" data-id="element-84">
            Keith Price
          </Text>
          <Text color={TEAL} fontSize="sm" opacity={0.85} data-id="element-85">
            zMagic Solutions
          </Text>
        </Box>
      </Flex>

      {/* Menu Items */}
      <VStack align="stretch" spacing={0} flex={1} pt={2} data-id="element-86">
        {/* Home */}
        <MenuItem icon={<Home size={26} strokeWidth={1.8} data-id="element-88" />} label="Home" onClick={() => navigate('/welcome')} data-id="element-87" />

        {/* Boards / Committees Radio Group + Dropdown */}
        <Box px={5} pt={3} pb={2} data-id="element-89">
          <RadioGroup value={selection} onChange={handleSelectionNavigate} colorScheme="teal" data-id="element-90">
            <Stack direction="column" spacing={2} data-id="element-91">
              <Radio value="boards" size="md" data-id="element-92">
                <Text color={TEAL} fontWeight="500" fontSize="md" data-id="element-93">
                  Boards
                </Text>
              </Radio>
              <Radio value="committees" size="md" data-id="element-94">
                <Text color={TEAL} fontWeight="500" fontSize="md" data-id="element-95">
                  Committees
                </Text>
              </Radio>
            </Stack>
          </RadioGroup>

          {/* Dropdown */}
          <Box mt={3} data-id="element-96">
            {selection === 'boards' ? <Select placeholder="Select Board" value={boardValue} onChange={handleBoardSelect} size="sm" borderColor={TEAL} focusBorderColor={TEAL} color={TEAL} _placeholder={{
            color: TEAL
          }} sx={{
            '> option': {
              color: '#333'
            }
          }} data-id="element-97">
                <option value="board_one" data-id="element-98">Board One</option>
                <option value="board_two" data-id="element-99">Board Two</option>
              </Select> : <Select placeholder="Select Committee" value={committeeValue} onChange={handleCommitteeSelect} size="sm" borderColor={TEAL} focusBorderColor={TEAL} color={TEAL} _placeholder={{
            color: TEAL
          }} sx={{
            '> option': {
              color: '#333'
            }
          }} data-id="element-100">
                <option value="committee_one" data-id="element-101">Committee One</option>
                <option value="committee_two" data-id="element-102">Committee Two</option>
                <option value="committee_three" data-id="element-103">Committee Three</option>
                <option value="committee_four" data-id="element-104">Committee Four</option>
                <option value="committee_five" data-id="element-105">Committee Five</option>
              </Select>}
          </Box>
        </Box>

        {/* Divider */}
        <Box px={4} py={3} data-id="element-106">
          <Divider borderColor="rgba(0,137,123,0.4)" data-id="element-107" />
        </Box>

        {/* Download */}
        <MenuItem icon={<Download size={26} strokeWidth={1.8} data-id="element-109" />} label="Download" data-id="element-108" />

        {/* Account */}
        <MenuItem icon={<Settings size={26} strokeWidth={1.8} data-id="element-111" />} label="Account" onClick={() => navigate('/account')} data-id="element-110" />

        {/* Log Out */}
        <MenuItem icon={<LogOut size={26} strokeWidth={1.8} data-id="element-113" />} label="Log Out" onClick={() => navigate('/login')} data-id="element-112" />
      </VStack>
    </Box>;
}